import eventTerms from './data/event-terms-hk'
import eventTermsTradego from './data/event-terms-tradego-hk'
import eventTermsMultiple from './data/event-terms-multiple-hk'
import activityNewUser8 from './data/activity-new-user8-hk'
import activityEssenceReward from './data/activity-essence-reward-hk'
import activityInviteFriend from './data/activity-invite-friend-hk'
import activityUsTrade from './data/activity-us-trade-hk'
import activityTradeExpert from './data/activity-trade-expert-hk'
import activityStockTrans from './data/activity-stock-trans-hk'
import activityTradeStar from './data/activity-trade-star-hk'
import inviteFriend from './data/invite-friend-hk'

export default {
  // 通用翻譯
  common: {
    confirm: '確定',
    return: '返回',
    cancel: '取消',
    noData: '暫無數據',
    reminder: '溫馨提示',
    defaultInputHolder: '請輸入',
    defaultSelectHolder: '請選擇',
    copySuccess: '複製成功',
    copyNotSupport: '當前設備不支持複製',
    loadMore: '加載更多',
    noMore: '暫無更多',
    open: '打開',
    reqError: '請求失敗，請稍後重試',
    stayTuned: '敬請期待',
    commonUse: '常用',
    goAppHandle: '請前往app進行操作',
    activityTime: '活動時間',
    appVersionNeedUpdate: '需更新app版本，以查看最新内容',
    hkCurrency: '港元',
    shareAppIntro: '盈寶證券-港股證券股市行情資訊社區平台\n實時行情海量資訊、牛人解讀讓您輕鬆把握投資機會',
    iKnowThat: '我知道了',
    openApp: '打開App'
  },

  router: {
    winbull: '盈寶證券',
    areaList: '國家/地區',
    download: '下載App'
  },

  login: {
    signIn: '登錄',
    signUp: '註冊',
    enterPhone: '請輸入手機號',
    pleaseEnterCorrectPhone: '請輸入正確的手機號',
    enterVcode: '輸入驗證碼',
    pleaseEnterVcode: '請輸入驗證碼',
    sendVcode: '發送驗證碼',
    reSendVcode: '重新發送驗證碼',
    countdown: '倒計時',
    pleasePickUserStatement: '請勾選用戶協議',
    firstSignWillRegister: '首次登錄將自動註冊賬號',
    iAgreed: '我已同意',
    serviceAgreement: '服務協議',
    registrationAgreement: '註冊協議',
    and: '及',
    privacyAgreement: '隱私協議',

    userAccountLocked: '賬號已鎖定',
    pleaseCall: '請致電',
    serviceHotline: '服務熱線',
    hongkongHotline: '香港',
    otherHotline: '其他',
    signInSuccess: '登錄成功',
    registerChannelValid: '原有渠道已失效，點擊跳轉至官方渠道',

    captchaTitle: '請完成安全驗證後繼續：',
    captchaTips: '按住左邊按鈕拖動完成上方拼圖',
    captchaVerifySuccess: '驗證成功',
    captchaVerifyFail: '驗證失敗，請重試',
    captchaOutTime: '驗證碼已過期，請重試'
  },

  loginActivity: {
    newUserTxt1: '邀請您加入盈寶',
    newUserTxt2: '新人禮包直送<span>HK$2000+</span>',
    newUserIntro1: '注册就送<span>HK$88</span>禮包',
    newUserIntro2: '<span>0門檻開戶</span>立享雙重禮',
    newUserIntro3: '首筆入金到賬HK$ 10000（或等值美元）及以上送<span>HK$800+</span>福利券',
    newUserIntro4: '額外再送邀請禮-<span>美股股票卡</span>',
    winbullIntroTitle: '為什麼選擇盈寶證券',
    winbullIntro1: '1分鐘極速開戶，便捷入金',
    winbullIntro2: '資金不閒置，貨幣基金T+0申贖，日日享收益',
    winbullIntro3: '自營投資組合，低回撤高收益，全球資產配寘',
    winbullIntro4: '免費會員永不降級，港美股0佣金，融資利率低至5.6%',
    winbullIntro5: '一站式投資全球，一鍵開通港股、美股、基金帳戶',
    winbullIntro6: '安全保障，持有香港證監會頒發的第1/4/9類牌照',
    receiveReward: '領取獎勵',
    registerReceive: '即刻註冊領取'
  },

  download: {
    introText1: '免費加入會員享零傭金交易港美股',
    introText2: '持牌經紀人一對一服務',
    weixinDownloadTips: '請點擊右上角按鈕，選擇在瀏覽器中打開',
    openDownloadTips1: '請點擊右上角',
    openDownloadTips2: '選擇瀏覽器打開',
    signUpSuccess: '註冊成功！ ',
    pageDescTips: '只差一步就能體驗全球投資樂趣<br />點擊下載APP按鈕，登錄完成開戶',
    downloadAppTips: '下載盈寶證券APP',
    downloadAppDesc: '新人福利大禮包現金贈股送不停，最高50倍日內融資'
  },

  activity: {
    goInApp: '進入盈寶證券APP',
    checkActivityDetail: '查看活動詳情',
    knowIt: '已了解',
    pleaseUpdateApp: '請更新APP最新版本後體驗',

    activityExplain: '本活動最終解釋權歸盈寶證券所有',
    activityEndDone: '活動已結束，感謝關注',
    releaseCountZero: '感謝關注活動，優惠券已發完',
    activityRule: '活動規則',
    activityRule2: '規則說明',
    awardCondition: '首入金 ≥ 10萬HKD',
    activityTime: '活動時間：即日起 - 2022/12/31 23:59:59',
    receiveAward: '領取獎勵',
    activityDissatisfied: '不滿足參與活動條件',

    signUpGiftTitle: '註冊有禮',

    openAccountGiftTitle: '開戶有禮',
    hkLv2: '港股Lv2',
    day: '天',
    hkLv2Quote: '港股LV2高級行情',

    cashInGiftTitle: '入金有禮',
    cashInDesc1: '首入金 ≥ 10萬HKD',
    cashInDesc2: '2萬HKD ≤ 入金 < 10萬HKD',
    receive: '領',

    winbullIntroduceTitle: '為什麼選擇盈寶',
    winbullIntroduceTitle2: '為什麼選擇盈寶證券',
    wbIntroTitle1: '持牌券商',
    wbIntroDesc1: '獲認可的互聯網券商，擁有1、4、9牌照',
    wbIntroTitle2: '產品理念',
    wbIntroDesc2: '以資產增值為目標，實現財富穩步增長',
    wbIntroTitle3: '知識社區',
    wbIntroDesc3: '專業知識分享社區，增值個人投資知識',
    wbIntroTitle4: '專業投顧',
    wbIntroDesc4: '連接專業投顧團隊，強化資產管理模式',

    activityTips:
      '本活動優惠及廣告不構成任何證券、金融產品或工具邀約、招攬、建議、意見或任何保證。投資有風險，入市需謹慎。 ',

    immediatelyOpen: '立即開戶'
  },

  activityTradego: {
    activityTime: '活動時間：即日起至2022年11月30日 23:59:59',
    jd50GiftCard: '50元京東卡',
    hkNo6MonthCommission: '6個月港股免佣',
    cashInGiftTips: '提示：需 30 天內不出金及交易 1 次'
  },

  activityMultiple: {
    activityTime: '活動時間：即日起至2022年12月31日 23:59:59',
    aliTarget: '阿裡系全體員工',
    xiaomiTarget: '小米系全體員工',
    tencentTarget: '騰訊系全體員工'
  },

  doc: {
    eventTerms: eventTerms,
    eventTermsTradego: eventTermsTradego,
    eventTermsMultiple: eventTermsMultiple
  },

  openAccount: {
    readyTitle: '盈寶證券在線極速開戶',
    readyDesc: '1個賬戶投資港、美市場',
    readyEntryCnTitle: '內地用戶開戶',
    readyEntryCnDesc1: '7*24h',
    readyEntryCnDesc2: '領新人福利大禮包',
    readyEntryHkTitle: '香港用戶開戶',
    readyEntryHkDesc1: '知識社區',
    readyEntryHkDesc2: '匯聚全球星級投資達人',

    reviewingTitle: '開戶資料審核中',
    reviewingDesc1: '預計1-3個工作日完成審核，',
    reviewingDesc2: '通過審核後更新內容即可生效，請耐心等待',

    failTitle: '未通過開戶審核，請重新提交資料',
    failReason: '原因',
    goToSubmit: '去提交',

    setPwdDialogTitle: '設置登錄密碼後才可進行開戶',
    nextTime: '下次再說',
    goSetting: '前往設置'
  },

  setPwd: {
    setUserPwd: '設置登錄密碼',
    phoneNumber: '手機號碼',
    vcode: '驗證碼',
    pleaseEnterVcode: '請輸入驗證碼',
    newPwd: '新密碼',
    pleaseEnterNewPwd: '請輸入新密碼',
    rePwd: '確認新密碼',
    pleaseEnterNewPwdAgain: '請再次輸入新密碼',
    pwdRuleTips: '密碼為6-12位字符、數字組合',
    pwdFormatErr: '密碼格式不正確',
    doublePwdErr: '兩次密碼輸入不符',
    setSuccess: '設置成功'
  },

  wxBindRes: {
    bindSuccess: '綁定成功',
    bindSuccessTips: '綁定成功，將會收到最新的消息提醒',
    bindFail: '綁定失敗',
    bindFailTips: '綁定失敗，請聯繫盈寶客服或稍後再試',
    bindHasPass: '賬號已綁定',
    bindHasPassTips: '請勿重複綁定賬號'
  },

  activitySeedUser: {
    pageTitle: '新客豪禮活動',
    giftOneTitle: '開戶大禮包',
    giftTwoTitle: '首入金獎勵',
    giftThreeTitle: '更多獎勵',
    noCommission: '免佣&平台費',
    noCommissionHk: '90天港股免佣金及平台費',
    noCommissionUs: '90天美股免佣金及平台費',

    giftTwoLeft1: '首入金 ≥ 2萬HKD或等值美金',
    giftTwoLeft2: '首入金 ≥ 10萬HKD或等值美金',
    giftTwoRight1: '獎勵400HKD',
    giftTwoRight2: '獎勵1500HKD',
    giftTwoTips: '提示：首入金獎勵需30天不出金，並且30天至少交易一次',

    moreCardTxtTop1: '30天',
    moreCardTxtBottom1: '港股Lv2',
    moreTitle1: '新註冊用戶即贈',
    moreDesc1: '30天港股Lv2串流行情報價',
    moreDescTips1: '',
    moreCardTxtTop2: '2000元',
    moreCardTxtBottom2: '京東卡',
    moreTitle2: '收益率排行最高',
    moreDesc2: '可得2000元京東卡',
    moreDescTips2: '(具體看活動規則)',
    moreCardTxtTop3: '300HKD',
    moreCardTxtBottom3: '反饋獎勵',
    moreTitle3: '產品優化反饋獎勵',
    moreDesc3: '一經採用，獎勵300～500HKD',
    moreDescTips3: '',

    shareTitle: '新客入金最高可領1500現金',
    shareContent: '開戶入金免手續費，還有更多好禮贈送',
    immediatelyOpen: '立即開戶',
    immediatelyCash: '立即入金',
    activityDissatisfied: '不滿足參與條件'
  },

  activityNewUser: {
    pageTitle: '新客豪禮活動',
    cardOneTitle: '開戶大禮包',
    cardTwoTitle: '如何拿到獎勵',
    cardThreeTitle: '選擇盈寶',

    cardOneDesc1: '首入金HKD 20000及以上，<br />30天未出金且交易一次',
    cardOneDesc2: '180天港股Lv2極速串流報價',
    cardOneFixed1: '現金券',
    cardOneFixed2: '行情券',

    cardTwoDesc1: '輸入手機號<br />並登錄APP',
    cardTwoDesc2: '點擊交易<br />完成開戶',
    cardTwoDesc3: '入金滿2W<br />發放卡券',

    cardThreeItemTitle1: '以幫助客戶盈利為目標',
    cardThreeItemDesc1: '智能盯盤，智盈策略，投資決策更高效',
    cardThreeItemTitle2: '超級會員權益',
    cardThreeItemDesc2: '港股佣金+美股佣金+暗盤佣金低至0元',
    cardThreeItemTitle3: '新型經紀人',
    cardThreeItemDesc3: '持牌經紀人，一對一專業服務',
    cardThreeItemTitle4: '互動社區',
    cardThreeItemDesc4: '社區有溫度內容有深度，大咖互動接觸財富快人一步',
    cardThreeItemTitle5: '一站式交易',
    cardThreeItemDesc5: '支持港股、美股、基金等投資標的，享受多元投資體驗',
    receiveAward: '領取獎勵',

    shareTitle: '盈寶HK$500現金券大派送',
    shareContent: '開戶入金最高可得HKD$500',
    immediatelyOpen: '立即開戶',
    immediatelyCash: '立即入金',
    activityDissatisfied: '不滿足參與條件'
  },
  // 地區
  location: {
    motherCountry: '中國',
    hongKong: '香港',
    maCao: '澳門',
    taiWan: '台灣'
  },

  inviteFriend: inviteFriend,

  activityNewUser8: activityNewUser8,

  activityEssenceReward: activityEssenceReward,

  activityInviteFriend: activityInviteFriend,

  activityUsTrade: activityUsTrade,

  activityTradeExpert: activityTradeExpert,

  activityStockTrans: activityStockTrans,

  activityTradeStar: activityTradeStar
}
